<template>
	<div
		@click="$emit('click', $event)"
		class="omapi-card-setting-section"
		:class="{'disabled': showProUpsells}"
	>
		<header>
			<h3>
				Display Powered By Link
			</h3>
		</header>
		<div>
			<div v-if="showTogglePoweredBy" class="omapi-input-wrap omapi-input-wrap-column">
				<common-toggle-input
					:disabled="showProUpsells"
					v-model="poweredBy"
				/>
			</div>

			<div v-if="poweredBy">
				<div class="omapi-input-wrap">
					<common-tooltip
						tooltip="We will pay you a 20% commission on every sale you generate using your referral link. All you
					have to do is recommend OptinMonster using your affiliate link on your website, blog, Facebook,
					Twitter or other social networks."
					>
						<label for="omapi-affiliate-link">Affiliate Link:</label>
					</common-tooltip>
					<input
						id="omapi-affiliate-link"
						type="url"
						class="omapi-input"
						name="affiliateLink"
						:value="affiliateLink"
						@change="$emit('input', $event)"
						placeholder="https://optinmonster.com"
					/>
				</div>
				<p>
					We will pay you a 20% commission on every sale you generate using your referral link. All you
					have to do is recommend OptinMonster using your affiliate link on your website, blog, Facebook,
					Twitter or other social networks.
					<a :href="$urls.marketing('affiliates/?utm_source=WordPress&utm_medium=AffiliateLink&utm_campaign=Plugin')" class="omapi-link-arrow-after" rel="noopener" target="_blank">Learn more</a>
				</p>
				<div class="omapi-input-wrap omapi-affiliate-link-position-setting">
					<common-tooltip
						tooltip="Determines the position of the OptinMonster badge on your campaigns."
					>
						<label for="omapi-affiliate-link-position">Position:</label>
					</common-tooltip>
					<div>
						<select
							id="omapi-affiliate-link-position"
							v-model="position"
						>
							<option value="bottom">Bottom</option>
							<option value="under">Under</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
import { mapGetters } from 'vuex'

export default  {
	props : {
		affiliateLink         : String,
		affiliateLinkPosition : {
			type    : String,
			default : 'bottom',
		},
		showTogglePoweredBy : {
			type    : Boolean,
			default : true,
		},
	},
	data () {
		return {
			poweredBy : true,
			position  : this.affiliateLinkPosition,
		}
	},
	watch : {
		affiliateLinkPosition (newVal) {
			if (newVal !== this.position) {
				this.position = newVal
			}
		},
		position (newVal) {
			if (newVal !== this.affiliateLinkPosition) {
				this.$emit('select', newVal, { name: 'affiliateLinkPosition' })
			}
		},
		poweredBy (newVal) {
			this.$emit('toggle', newVal)
		},
	},
	computed : {
		...mapGetters([ 'showProUpsells' ]),
	},
}
</script>

<style lang="scss">
@import '../../assets/scss/variables';
#omapi-affiliate-link-position {
	border-color: $color_grey-border;
}
.omapi-affiliate-link-position-setting {
	display: flex;
	align-items: center;
	> span {
		padding-right: 10px;
	}
}
</style>
